import axios from "axios";
import { format } from "date-fns";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../../../../Context/UserContextAPI";
import BarCodeInInvoice from "../../Invoice/components/BarCodesInInvoice";
import ExpDateAndResultInReports from "./Components/ExpDateAndResultInReports";
import LaboratoryInvestigatoinTest from "./Components/LaboratoryInvestigationTest";
import MedicalExaminationTest from "./Components/MedicalExaminationTest";
import RemarksInReport from "./Components/RemarksInTest";
import SignatureInReports from "./Components/SignatureInReports";
import StaticContentInReport from "./Components/StaticContentInReport";
import UserInfoTable from "./Components/UserInfoTable";
import "./HeldUp.scss";

const Fit = ({ noHeader, user_id }) => {
  let { userId } = useParams();
  userId = user_id ? user_id : userId;
  const { currentUser, accessPerm, settingsData } = useContext(UserContext);

  const [userDetail, setUserDetail] = useState();
  const [user, setUser] = useState();
  const [pathologyCommentRisk, setPathologyCommentRisk] = useState();
  const [physicalCommentRisk, setPhysicalCommentRisk] = useState();

  const urlWithBase64ID = settingsData?.qrcode_url;

  const [radiologyData, setRadiologyData] = useState([]);
  const [pathologyData, setPathologyData] = useState([]);
  const [physicalData, setPhysicalData] = useState([]);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const getUserDetail = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/user-details/test/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        },
      );
      setUserDetail(response?.data?.data?.userDetail);
    } catch (error) {
      console.error(error);
    }
  };

  const getRadiologyTests = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/radiology/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        },
      );

      setRadiologyData(response?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getPhysicalTests = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/physical/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        },
      );

      setPhysicalData(response?.data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getPathologyData = () => {
    axios
      .get(
        `${
          process.env.REACT_APP_API_BASE_URL
        }/reports/get-healthcard-results/${userId}/${1}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((response) => {
        setPathologyData(response?.data);
      })
      .catch((err) => console.log(err));
  };

  const getPathologyComment = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/get-pathology-comments/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const commentsData = response?.data?.data;
      setPathologyCommentRisk(commentsData?.comments);
    } catch (error) {
      console.error(error);
    }
  };

  const getPhysicalComment = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/reports/get-physical-comments/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const commentsData = response?.data?.data;

      setPhysicalCommentRisk(commentsData?.comments);
    } catch (error) {
      console.error(error);
    }
  };

  const groupedData = useMemo(() => {
    return physicalData.reduce((acc, item) => {
      const categoryName = item?.investigation?.investigation_category?.name;
      if (!categoryName) return acc;
      if (!acc[categoryName]) {
        acc[categoryName] = {
          name: categoryName,
          items: [],
        };
      }
      acc[categoryName].items.push(item);
      return acc;
    }, {});
  }, [physicalData]);

  const groupedPathologyData = useMemo(() => {
    return pathologyData.reduce((acc, item) => {
      const categoryName =
        item?.investigation_test?.investigation?.investigation_category?.name;

      if (!categoryName) return acc;
      if (!acc[categoryName]) {
        acc[categoryName] = {
          name: categoryName,
          items: [],
        };
      }

      acc[categoryName].items.push(item);

      return acc;
    }, {});
  }, [pathologyData, userDetail?.gender?.id]);

  useEffect(() => {
    getRadiologyTests();
    getPhysicalTests();
    getPathologyData();
    getPathologyComment();
    getPhysicalComment();
    getUserDetail();
  }, [userId]);

  useEffect(() => {
    userDetail && setUser(userDetail?.user);
  }, [userDetail]);

  /**
   * Get the age of the user
   * @param {Object} userData - The user data
   * @returns {string} The age of the user
   */
  const getUserAge = (userData) => {
    const currentYear = new Date().getFullYear();
    const birthYear = userData?.date_of_birth
      ? new Date(userData?.date_of_birth).getFullYear()
      : null;
    if (birthYear) {
      return `${currentYear - birthYear}Y`;
    }
    return "---";
  };

  /**
   * Format the date
   * @param {string} inputDate - The input date
   * @returns {string} The formatted date
   */
  function formatDate(inputDate) {
    try {
      const date = new Date(inputDate);

      return format(date, "dd-MM-yyyy hh:mm a");
    } catch (error) {
      console.error("Error parsing date:", error);
      return "Invalid date";
    }
  }

  const radiologyResult = radiologyData?.find(
    (report) => report?.investigation_test?.id === 35,
  )?.result;

  const physicalRemarksItem = Object.entries(groupedData)
    .flatMap((group) => group[1].items)
    .find(
      (item) =>
        item?.investigation?.name?.toLowerCase() ===
        "Physical Remarks".toLocaleLowerCase(),
    );
  return (
    <>
      <section className="held-up-certificate d-flex flex-column justify-content-between">
        <div className="row align-items-center">
          <img
            src={`${process.env.REACT_APP_UPLOAD_URL}/${settingsData?.header_image}`}
            alt="Report Header"
            className="mx-auto"
            style={{
              width: "100%",
              visibility: noHeader ? "hidden" : "visible",
            }}
          />
        </div>
        <div className="">
          {/* Empty div to take up the left space */}

          {/* Medical Form centered */}
          <div
            className="text-center text-uppercase text-dark fs-5"
            style={{ textDecoration: "underline", fontWeight: "bolder" }}
          >
            General Medical Exam Report
          </div>
        </div>

        <div className="d-flex justify-content-between fw-bolder">
          <div>
            <p className="fs-6">
              Reg No : {user?.reg_prefix}
              {user?.registration_no}{" "}
            </p>
          </div>
          <div>
            <p className="fs-6">
              Reg Date :{" "}
              {formatDate(user?.createdAt, "dd-MM-yyyy hh:mm a")}{" "}
            </p>
          </div>
        </div>

        {/* bar code  */}
        <BarCodeInInvoice userDetail={userDetail} hasPrefixInRegBar />
        <UserInfoTable
          user={user}
          userDetails={userDetail}
          age={getUserAge(user)}
          physicalData={physicalData}
        />

        <StaticContentInReport settingsData={settingsData} />
        <div className="row  mt-1 ">
          <div className="col-sm-12 d-flex flex-column flex-sm-row">
            {(Object.entries(groupedData)?.length > 0 ||
              radiologyData?.length > 0) && (
              <div
                className={`${
                  Object.entries(groupedPathologyData)?.length > 0
                    ? "col-sm-6"
                    : "col-sm-12"
                }`}
              >
                <MedicalExaminationTest
                  groupedData={groupedData}
                  radiologyData={radiologyData}
                  radiologyResult={radiologyResult}
                  user={user}
                />
                {/* this componet will show if the labotary data in not there and its width will show 100% if MedicalExamination is half screen but if full screen it will be 50% */}
                <div
                  style={{
                    width: `${
                      Object.entries(groupedPathologyData)?.length > 0
                        ? "100%"
                        : "50%"
                    }`,
                  }}
                >
                  <ExpDateAndResultInReports
                    userDetail={userDetail}
                    user={user}
                  />
                </div>
              </div>
            )}
            {Object.entries(groupedPathologyData)?.length > 0 && (
              <div
                className={
                  Object.entries(groupedData)?.length > 0 ||
                  radiologyData.length > 0
                    ? "col-sm-6 ps-2"
                    : "col-sm-12"
                }
              >
                <LaboratoryInvestigatoinTest
                  groupedPathologyData={groupedPathologyData}
                  user={user}
                />
              </div>
            )}
          </div>
        </div>

        {/* expriery date and remarks ------ this will not show if medical examication tablw show  */}
        {!(
          Object.entries(groupedData)?.length > 0 || radiologyData.length > 0
        ) && (
          <div style={{ width: "50%" }}>
            <ExpDateAndResultInReports
              userDetail={userDetail}
              user={user}
              physicalRemarksItem={physicalRemarksItem}
            />
          </div>
        )}
      </section>

      <RemarksInReport
        physicalCommentRisk={physicalCommentRisk}
        pathologyCommentRisk={pathologyCommentRisk}
        radiologyData={radiologyData}
      />

      <SignatureInReports
        urlWithBase64ID={urlWithBase64ID}
        currentUser={currentUser}
      />

      <div className="d-flex justify-content-end gap-2 heldup-button mt-2">
        {accessPerm(33, 23) && (
          <button className="btn btn-primary" onClick={() => window.print()}>
            Print
          </button>
        )}

        <button
          className="btn btn-outline-secondary"
          onClick={() => {
            window.close();
          }}
        >
          Close
        </button>
      </div>
    </>
  );
};

export default Fit;
